const tutorInitialState = {
    //Browse Tutor
    loadingBrowseStudentRequestedListApi: false,
    BrowseStudentRequestedListApiData: [],
    BrowseStudentRequestedListApiError: '',


    loadingBrowseStudentApprovedListApi: false,
    BrowseStudentApprovedListApiData: [],
    BrowseStudentApprovedListApiError: '',


    loadingBrowseStudentRequestedDetailApi: false,
    BrowseStudentRequestedDetailApiData: [],
    BrowseStudentRequestedDetailApiError: '',


    loadingBrowseStudentApprovedDetailApi: false,
    BrowseStudentApprovedDetailApiData: [],
    BrowseStudentApprovedDetailApiError: '',


    //category
    loadingTutorCategoryDataListApi: false,
    TutorCategoryDataListApiData: [],
    TutorCategoryDataListApiError: '',


    //tutor study material LIST
    loadingTutorStudyMaterialVideoListApi: false,
    TutorStudyMaterialVideoListApiData: [],
    TutorStudyMaterialVideoListApiError: '',

    loadingTutorStudyMaterialImageListApi: false,
    TutorStudyMaterialImageListApiData: [],
    TutorStudyMaterialImageListApiError: '',

    loadingTutorStudyMaterialPdfListApi: false,
    TutorStudyMaterialPdfListApiData: [],
    TutorStudyMaterialPdfListApiError: '',

    // PPT states
    loadingTutorStudyMaterialPptListApi: false,
    TutorStudyMaterialPptListApiData: [],
    TutorStudyMaterialPptListApiError: '',

    // DOC states
    loadingTutorStudyMaterialDocListApi: false,
    TutorStudyMaterialDocListApiData: [],
    TutorStudyMaterialDocListApiError: '',


    //tutor study material group
    loadingTutorStudyMaterialGroupListApi: false,
    TutorStudyMaterialGroupListApiData: [],
    TutorStudyMaterialGroupListApiError: '',


    //GROUP category
    loadingTutorGroupCategoryDataListApi: false,
    TutorGroupCategoryDataListApiData: [],
    TutorGroupCategoryDataListApiError: '',

    //ONE TO ONE category
    loadingTutorOneCategoryDataListApi: false,
    TutorOneCategoryDataListApiData: [],
    TutorOneCategoryDataListApiError: '',


    //GROUP category
    loadingTutorGroupSubCategoryDataListApi: false,
    TutorGroupSubCategoryDataListApiData: [],
    TutorGroupSubCategoryDataListApiError: '',

    //ONE TO ONE Subcategory
    loadingTutorOneSubCategoryDataListApi: false,
    TutorOneSubCategoryDataListApiData: [],
    TutorOneSubCategoryDataListApiError: '',


    //GROUP category
    loadingTutorGroupChildCategoryDataListApi: false,
    TutorGroupChildCategoryDataListApiData: [],
    TutorGroupChildCategoryDataListApiError: '',

    //ONE TO ONE Childcategory
    loadingTutorOneChildCategoryDataListApi: false,
    TutorOneChildCategoryDataListApiData: [],
    TutorOneChildCategoryDataListApiError: '',

    loadingTutorMyCourseGroupListApi: false,
    TutorMyCourseGroupListApiData: [],
    TutorMyCourseGroupListApiError: '',

    loadingTutorMyCourseOneListApi: false,
    TutorMyCourseOneListApiData: [],
    TutorMyCourseOneListApiError: '',

    loadingTutorMyCourseGroupBatchListApi: false,
    TutorMyCourseGroupBatchListApiData: [],
    TutorMyCourseGroupBatchListApiError: '',

    loadingTutorMyBookedScheduleOneListApi: false,
    TutorMyBookedScheduleOneListApiData: [],
    TutorMyBookedScheduleOneListApiError: '',

    loadingTutorMyBookedScheduleGroupListApi: false,
    TutorMyBookedScheduleGroupListApiData: [],
    TutorMyBookedScheduleGroupListApiError: '',

    loadingTutorMyBookedScheduleDetailApi: false,
    TutorMyBookedScheduleDetailApiData: [],
    TutorMyBookedScheduleDetailApiError: '',

    loadingTutorCompletedAssListApi: false,
    TutorCompletedAssListApiData: [],
    TutorCompletedAssListApiError: '',

    loadingTutorViewAssListApi: false,
    TutorViewAssListApiData: [],
    TutorViewAssListApiError: '',

    loadingTutorViewAssDetailApi: false,
    TutorViewAssDetailApiData: [],
    TutorViewAssDetailApiError: '',

    loadingTutorCompletedAssStudentListApi: false,
    TutorCompletedAssStudentListApiData: [],
    TutorCompletedAssStudentListApiError: '',

    loadingTutorCompletedAssStudentDetailApi: false,
    TutorCompletedAssStudentDetailApiData: [],
    TutorCompletedAssStudentDetailApiError: '',

    loadingTutorBookedStudentListApi: false,
    TutorBookedStudentListApiData: [],
    TutorBookedStudentListApiError: '',

    loadingMyBookingsListApi: false,
    MyBookingsListApiData: [],
    MyBookingsListApiError: '',

    loadingTutorNotificationListApi: false,
    TutorNotificationListApiData: [],
    TutorNotificationListApiError: '',

    loadingTutorQueryListApi: false,
    TutorQueryListApiData: [],
    TutorQueryListApiError: '',

    loadingTutorQueriesDetailApi: false,
    TutorQueriesDetailApiData: [],
    TutorQueriesDetailApiError: '',


    loadingTutorReviewDataApi: false,
    TutorReviewDataApiData: [],
    TutorReviewDataApiError: '',

    loadingTutorMyEarningDataApi: false,
    TutorMyEarningDataApiData: [],
    TutorMyEarningDataApiError: '',

    loadingTutorSmallNotificationListApi: false,
    TutorSmallNotificationListApiData: [],
    TutorSmallNotificationListApiError: '',



}

const TutorReducer = (state = tutorInitialState, action) => {
    switch (action.type) {


        case 'FETCH_BROWSE_STUDENT_REQUESTED_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingBrowseStudentRequestedListApi: true,
                BrowseStudentRequestedListApiError: '',
            };
        case 'FETCH_BROWSE_STUDENT_REQUESTED_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingBrowseStudentRequestedListApi: false,
                BrowseStudentRequestedListApiData: action.payload,
            };
        case 'FETCH_BROWSE_STUDENT_REQUESTED_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingBrowseStudentRequestedListApi: false,
                BrowseStudentRequestedListApiError: action.payload,
            };

        case 'FETCH_BROWSE_STUDENT_APPROVED_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingBrowseStudentApprovedListApi: true,
                BrowseStudentApprovedListApiError: '',
            };
        case 'FETCH_BROWSE_STUDENT_APPROVED_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingBrowseStudentApprovedListApi: false,
                BrowseStudentApprovedListApiData: action.payload,
            };
        case 'FETCH_BROWSE_STUDENT_APPROVED_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingBrowseStudentApprovedListApi: false,
                BrowseStudentApprovedListApiError: action.payload,
            };


        case 'FETCH_BROWSE_STUDENT_REQUESTED_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingBrowseStudentRequestedDetailApi: true,
                BrowseStudentRequestedDetailApiError: '',
            };
        case 'FETCH_BROWSE_STUDENT_REQUESTED_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingBrowseStudentRequestedDetailApi: false,
                BrowseStudentRequestedDetailApiData: action.payload,
            };
        case 'FETCH_BROWSE_STUDENT_REQUESTED_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingBrowseStudentRequestedDetailApi: false,
                BrowseStudentRequestedDetailApiError: action.payload,
            };


        case 'FETCH_BROWSE_STUDENT_APPROVED_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingBrowseStudentApprovedDetailApi: true,
                BrowseStudentApprovedDetailApiError: '',
            };
        case 'FETCH_BROWSE_STUDENT_APPROVED_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingBrowseStudentApprovedDetailApi: false,
                BrowseStudentApprovedDetailApiData: action.payload,
            };
        case 'FETCH_BROWSE_STUDENT_APPROVED_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingBrowseStudentApprovedDetailApi: false,
                BrowseStudentApprovedDetailApiError: action.payload,
            };


        case 'FETCH_TUTOR_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorCategoryDataListApi: true,
                TutorCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorCategoryDataListApi: false,
                TutorCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorCategoryDataListApi: false,
                TutorCategoryDataListApiError: action.payload,
            };


        case 'FETCH_TUTOR_STUDY_MATERIAL_VIDEO_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorStudyMaterialVideoListApi: true,
                TutorStudyMaterialVideoListApiError: '',
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_VIDEO_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorStudyMaterialVideoListApi: false,
                TutorStudyMaterialVideoListApiData: action.payload,
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_VIDEO_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorStudyMaterialVideoListApi: false,
                TutorStudyMaterialVideoListApiError: action.payload,
            };


        case 'FETCH_TUTOR_STUDY_MATERIAL_IMAGE_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorStudyMaterialImageListApi: true,
                TutorStudyMaterialImageListApiError: '',
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_IMAGE_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorStudyMaterialImageListApi: false,
                TutorStudyMaterialImageListApiData: action.payload,
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_IMAGE_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorStudyMaterialImageListApi: false,
                TutorStudyMaterialImageListApiError: action.payload,
            };


        case 'FETCH_TUTOR_STUDY_MATERIAL_PDF_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorStudyMaterialPdfListApi: true,
                TutorStudyMaterialPdfListApiError: '',
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_PDF_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorStudyMaterialPdfListApi: false,
                TutorStudyMaterialPdfListApiData: action.payload,
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_PDF_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorStudyMaterialPdfListApi: false,
                TutorStudyMaterialPdfListApiError: action.payload,
            };

        // PPT cases
        case 'FETCH_TUTOR_STUDY_MATERIAL_PPT_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorStudyMaterialPptListApi: true,
                TutorStudyMaterialPptListApiError: '',
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_PPT_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorStudyMaterialPptListApi: false,
                TutorStudyMaterialPptListApiData: action.payload,
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_PPT_LIST_DATA_FAILURE':
            return {
                ...state,
                loadingTutorStudyMaterialPptListApi: false,
                TutorStudyMaterialPptListApiError: action.payload,
            };

        // DOC cases
        case 'FETCH_TUTOR_STUDY_MATERIAL_DOC_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorStudyMaterialDocListApi: true,
                TutorStudyMaterialDocListApiError: '',
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_DOC_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorStudyMaterialDocListApi: false,
                TutorStudyMaterialDocListApiData: action.payload,
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_DOC_LIST_DATA_FAILURE':
            return {
                ...state,
                loadingTutorStudyMaterialDocListApi: false,
                TutorStudyMaterialDocListApiError: action.payload,
            };


        case 'FETCH_TUTOR_STUDY_MATERIAL_GROUP_DATA_REQUEST':
            return {
                ...state,
                loadingTutorStudyMaterialGroupListApi: true,
                TutorStudyMaterialGroupListApiError: '',
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_GROUP_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorStudyMaterialGroupListApi: false,
                TutorStudyMaterialGroupListApiData: action.payload,
            };
        case 'FETCH_TUTOR_STUDY_MATERIAL_GROUP_DATA_FAILURE':

            return {
                ...state,
                loadingTutorStudyMaterialGroupListApi: false,
                TutorStudyMaterialGroupListApiError: action.payload,
            };


        case 'FETCH_TUTOR_GROUP_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorGroupCategoryDataListApi: true,
                TutorGroupCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_GROUP_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorGroupCategoryDataListApi: false,
                TutorGroupCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_GROUP_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorGroupCategoryDataListApi: false,
                TutorGroupCategoryDataListApiError: action.payload,
            };

        case 'FETCH_TUTOR_ONE_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorOneCategoryDataListApi: true,
                TutorOneCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_ONE_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorOneCategoryDataListApi: false,
                TutorOneCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_ONE_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorOneCategoryDataListApi: false,
                TutorOneCategoryDataListApiError: action.payload,
            };



        case 'FETCH_TUTOR_GROUP_SUB_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorGroupSubCategoryDataListApi: true,
                TutorGroupSubCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_GROUP_SUB_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorGroupSubCategoryDataListApi: false,
                TutorGroupSubCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_GROUP_SUB_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorGroupSubCategoryDataListApi: false,
                TutorGroupSubCategoryDataListApiError: action.payload,
            };


        case 'FETCH_TUTOR_ONE_SUB_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorOneSubCategoryDataListApi: true,
                TutorOneSubCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_ONE_SUB_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorOneSubCategoryDataListApi: false,
                TutorOneSubCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_ONE_SUB_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorOneSubCategoryDataListApi: false,
                TutorOneSubCategoryDataListApiError: action.payload,
            };


        case 'FETCH_TUTOR_GROUP_CHILD_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorGroupChildCategoryDataListApi: true,
                TutorGroupChildCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_GROUP_CHILD_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorGroupChildCategoryDataListApi: false,
                TutorGroupChildCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_GROUP_CHILD_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorGroupChildCategoryDataListApi: false,
                TutorGroupChildCategoryDataListApiError: action.payload,
            };


        case 'FETCH_TUTOR_ONE_CHILD_CATEGORY_DATA_REQUEST':
            return {
                ...state,
                loadingTutorOneChildCategoryDataListApi: true,
                TutorOneChildCategoryDataListApiError: '',
            };
        case 'FETCH_TUTOR_ONE_CHILD_CATEGORY_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorOneChildCategoryDataListApi: false,
                TutorOneChildCategoryDataListApiData: action.payload,
            };
        case 'FETCH_TUTOR_ONE_CHILD_CATEGORY_DATA_FAILURE':

            return {
                ...state,
                loadingTutorOneChildCategoryDataListApi: false,
                TutorOneChildCategoryDataListApiError: action.payload,
            };


        case 'FETCH_TUTOR_MY_COURSE_GROUP_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyCourseGroupListApi: true,
                TutorMyCourseGroupListApiError: '',
            };
        case 'FETCH_TUTOR_MY_COURSE_GROUP_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyCourseGroupListApi: false,
                TutorMyCourseGroupListApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_COURSE_GROUP_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyCourseGroupListApi: false,
                TutorMyCourseGroupListApiError: action.payload,
            };


        case 'FETCH_TUTOR_MY_COURSE_BATCH_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyCourseGroupBatchListApi: true,
                TutorMyCourseGroupBatchListApiError: '',
            };
        case 'FETCH_TUTOR_MY_COURSE_BATCH_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyCourseGroupBatchListApi: false,
                TutorMyCourseGroupBatchListApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_COURSE_BATCH_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyCourseGroupBatchListApi: false,
                TutorMyCourseGroupBatchListApiError: action.payload,
            };


        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_ONE_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyBookedScheduleOneListApi: true,
                TutorMyBookedScheduleOneListApiError: '',
            };
        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_ONE_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyBookedScheduleOneListApi: false,
                TutorMyBookedScheduleOneListApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_ONE_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyBookedScheduleOneListApi: false,
                TutorMyBookedScheduleOneListApiError: action.payload,
            };


        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_GROUP_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyBookedScheduleGroupListApi: true,
                TutorMyBookedScheduleGroupListApiError: '',
            };
        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_GROUP_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyBookedScheduleGroupListApi: false,
                TutorMyBookedScheduleGroupListApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_GROUP_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyBookedScheduleGroupListApi: false,
                TutorMyBookedScheduleGroupListApiError: action.payload,
            };


        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyBookedScheduleDetailApi: true,
                TutorMyBookedScheduleDetailApiError: '',
            };
        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyBookedScheduleDetailApi: false,
                TutorMyBookedScheduleDetailApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_BOOKED_SCHEDULE_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyBookedScheduleDetailApi: false,
                TutorMyBookedScheduleDetailApiError: action.payload,
            };



        case 'FETCH_TUTOR_MY_COURSE_ONE_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyCourseOneListApi: true,
                TutorMyCourseOneListApiError: '',
            };
        case 'FETCH_TUTOR_MY_COURSE_ONE_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyCourseOneListApi: false,
                TutorMyCourseOneListApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_COURSE_ONE_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyCourseOneListApi: false,
                TutorMyCourseOneListApiError: action.payload,
            };

        case 'FETCH_TUTOR_VIEW_ASS_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorViewAssListApi: true,
                TutorViewAssListApiError: '',
            };
        case 'FETCH_TUTOR_VIEW_ASS_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorViewAssListApi: false,
                TutorViewAssListApiData: action.payload,
            };
        case 'FETCH_TUTOR_VIEW_ASS_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorViewAssListApi: false,
                TutorViewAssListApiError: action.payload,
            };

        case 'FETCH_TUTOR_COMPLETED_ASS_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorCompletedAssListApi: true,
                TutorCompletedAssListApiError: '',
            };
        case 'FETCH_TUTOR_COMPLETED_ASS_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorCompletedAssListApi: false,
                TutorCompletedAssListApiData: action.payload,
            };
        case 'FETCH_TUTOR_COMPLETED_ASS_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorCompletedAssListApi: false,
                TutorCompletedAssListApiError: action.payload,
            };


        case 'FETCH_TUTOR_COMPLETED_ASS_STUDENT_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorCompletedAssStudentListApi: true,
                TutorCompletedAssStudentListApiError: '',
            };
        case 'FETCH_TUTOR_COMPLETED_ASS_STUDENT_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorCompletedAssStudentListApi: false,
                TutorCompletedAssStudentListApiData: action.payload,
            };
        case 'FETCH_TUTOR_COMPLETED_ASS_STUDENT_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorCompletedAssStudentListApi: false,
                TutorCompletedAssStudentListApiError: action.payload,
            };


        case 'FETCH_TUTOR_COMPLETED_ASS_STUDENT_DETAIL_REQUEST':
            return {
                ...state,
                loadingTutorCompletedAssStudentDetailApi: true,
                TutorCompletedAssStudentDetailApiError: '',
            };
        case 'FETCH_TUTOR_COMPLETED_ASS_STUDENT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingTutorCompletedAssStudentDetailApi: false,
                TutorCompletedAssStudentDetailApiData: action.payload,
            };
        case 'FETCH_TUTOR_COMPLETED_ASS_STUDENT_DETAIL_FAILURE':

            return {
                ...state,
                loadingTutorCompletedAssStudentDetailApi: false,
                TutorCompletedAssStudentDetailApiError: action.payload,
            };


        case 'FETCH_TUTOR_VIEW_ASS_DETAIL_REQUEST':
            return {
                ...state,
                loadingTutorViewAssDetailApi: true,
                TutorViewAssDetailApiError: '',
            };
        case 'FETCH_TUTOR_VIEW_ASS_DETAIL_SUCCESS':
            return {
                ...state,
                loadingTutorViewAssDetailApi: false,
                TutorViewAssDetailApiData: action.payload,
            };
        case 'FETCH_TUTOR_VIEW_ASS_DETAIL_FAILURE':

            return {
                ...state,
                loadingTutorViewAssDetailApi: false,
                TutorViewAssDetailApiError: action.payload,
            };


        case 'FETCH_TUTOR_BOOKED_STUDENT_LIST_REQUEST':
            return {
                ...state,
                loadingTutorBookedStudentListApi: true,
                TutorBookedStudentListApiError: '',
            };
        case 'FETCH_TUTOR_BOOKED_STUDENT_LIST_SUCCESS':
            return {
                ...state,
                loadingTutorBookedStudentListApi: false,
                TutorBookedStudentListApiData: action.payload,
            };
        case 'FETCH_TUTOR_BOOKED_STUDENT_LIST_FAILURE':

            return {
                ...state,
                loadingTutorBookedStudentListApi: false,
                TutorBookedStudentListApiError: action.payload,
            };


        case 'FETCH_MY_BOOKINGS_LIST_REQUEST':
            return {
                ...state,
                loadingMyBookingsListApi: true,
                MyBookingsListApiError: '',
            };
        case 'FETCH_MY_BOOKINGS_LIST_SUCCESS':
            return {
                ...state,
                loadingMyBookingsListApi: false,
                MyBookingsListApiData: action.payload,
            };
        case 'FETCH_MY_BOOKINGS_LIST_FAILURE':

            return {
                ...state,
                loadingMyBookingsListApi: false,
                MyBookingsListApiError: action.payload,
            };


        case 'FETCH_TUTOR_NOTIFICATION_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorNotificationListApi: true,
                TutorNotificationListApiError: '',
            };
        case 'FETCH_TUTOR_NOTIFICATION_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorNotificationListApi: false,
                TutorNotificationListApiData: action.payload,
            };
        case 'FETCH_TUTOR_NOTIFICATION_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorNotificationListApi: false,
                TutorNotificationListApiError: action.payload,
            };


        case 'FETCH_TUTOR_SMALL_NOTIFICATION_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorSmallNotificationListApi: true,
                TutorSmallNotificationListApiError: '',
            };
        case 'FETCH_TUTOR_SMALL_NOTIFICATION_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorSmallNotificationListApi: false,
                TutorSmallNotificationListApiData: action.payload,
            };
        case 'FETCH_TUTOR_SMALL_NOTIFICATION_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorSmallNotificationListApi: false,
                TutorSmallNotificationListApiError: action.payload,
            };

        case 'FETCH_TUTOR_QUERY_LIST_DATA_REQUEST':
            return {
                ...state,
                loadingTutorQueryListApi: true,
                TutorQueryListApiError: '',
            };
        case 'FETCH_TUTOR_QUERY_LIST_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorQueryListApi: false,
                TutorQueryListApiData: action.payload,
            };
        case 'FETCH_TUTOR_QUERY_LIST_DATA_FAILURE':

            return {
                ...state,
                loadingTutorQueryListApi: false,
                TutorQueryListApiError: action.payload,
            };

        case 'FETCH_TUTOR_QUERIES_DETAIL_DATA_REQUEST':
            return {
                ...state,
                loadingTutorQueriesDetailApi: true,
                TutorQueriesDetailApiError: '',
            };
        case 'FETCH_TUTOR_QUERIES_DETAIL_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorQueriesDetailApi: false,
                TutorQueriesDetailApiData: action.payload,
            };
        case 'FETCH_TUTOR_QUERIES_DETAIL_DATA_FAILURE':

            return {
                ...state,
                loadingTutorQueriesDetailApi: false,
                TutorQueriesDetailApiError: action.payload,
            };


        case 'FETCH_TUTOR_REVIEW_DATA_REQUEST':
            return {
                ...state,
                loadingTutorReviewDataApi: true,
                TutorReviewDataApiError: '',
            };
        case 'FETCH_TUTOR_REVIEW_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorReviewDataApi: false,
                TutorReviewDataApiData: action.payload,
            };
        case 'FETCH_TUTOR_REVIEW_DATA_FAILURE':

            return {
                ...state,
                loadingTutorReviewDataApi: false,
                TutorReviewDataApiError: action.payload,
            };

        case 'FETCH_TUTOR_MY_EARNINGS_DATA_REQUEST':
            return {
                ...state,
                loadingTutorMyEarningDataApi: true,
                TutorMyEarningDataApiError: '',
            };
        case 'FETCH_TUTOR_MY_EARNINGS_DATA_SUCCESS':
            return {
                ...state,
                loadingTutorMyEarningDataApi: false,
                TutorMyEarningDataApiData: action.payload,
            };
        case 'FETCH_TUTOR_MY_EARNINGS_DATA_FAILURE':

            return {
                ...state,
                loadingTutorMyEarningDataApi: false,
                TutorMyEarningDataApiError: action.payload,
            };

        default:
            return state;
    }
}
export default TutorReducer;